<template>
  <nav-bar  :title="dMess.departName" />
  <layout-sale :top="0" :role="1">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="department">
      <van-icon name="wap-home-o" />
      <span>{{ dMess.groupName }} </span>
    </div>
    <div class="row-btn">
      <van-row gutter="16">
        <van-col span="12">
          <van-button
            block
            plain size="small"
            type="primary" to ="/addCustomer">
            添加存量客户
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button type="primary" size="small" block plain to ="/extCustomerList" >开拓客户</van-button>
        </van-col>
      </van-row>
    </div>
    <van-cell-group title="用户情况">
      <van-search v-model="searchWord" placeholder="请输入用户名称" @search="onSearch" />
      <template v-for="item in cList"  :key="item.customerId">
        <van-cell :border="false"  :value="'钢瓶总数'+item.cylinderCount+'瓶'">
          <template #title>
            <div class="custom-title">{{item.customerName}}</div>
            <van-tag :type="item.legalFlag === '1' ? 'primary' : 'danger'">{{item.legalFlag === '1' ? '合法' : '非法'}}</van-tag>
            <div>
              <van-tag type="danger" v-if="item.accordFlag === '0'" round @click="toastInfo(item.accordRemark)" >信息不符</van-tag>
            </div>
          </template>
        </van-cell>
        <div class="btns">
          <van-row gutter="20">
            <van-col span="12">
              <van-button block type="primary" size="small"  @click="handleComClick(item)">详细</van-button>
            </van-col>
            <van-col span="12">
              <van-button block type="primary" size="small"  :to="`/modifySalesCust/${item.customerId}`">修改</van-button>
            </van-col>
            <van-col span="8">
              <van-button block type="primary" size="small"  @click="handleModClick(item.customerId)">合同修改</van-button>
            </van-col>
            <van-col span="8">
              <van-button block type="primary" size="small"  @click="handleHistoryClick(item.customerId)">修改历史</van-button>
            </van-col>
            <van-col span="8">
              <van-button block type="danger" size="small"  @click.stop="handleDelClick(item.customerId)">删除</van-button>
            </van-col>
        </van-row>
        </div>
      </template>
    </van-cell-group>
  </layout-sale>
  <Popup :title="showHistory? '修改历史' : '合同修改'" ref="popup" minHeight="100%">
    <div v-if="showHistory" class="popup-content">
      <ul class="list">
        <li class="list-item" v-for="item in historyList" :key="item.id">
          <div class="list-item__name">{{`${item.insertUserName}(${item.insertRoleName})于${item.insertTime}:`}}</div>
          <div class="list-item__content">{{item.remark}}</div>
        </li>
      </ul>
    </div>
       <van-form v-else>
          <Picker
              label="合同开始时间"
              pickerType="time"
              :defaultVal="contractSdate"
              @confirm-values="val => contractSdate = val"
            />
          <Picker
            label="合同结束时间"
            pickerType="time"
            :defaultVal="contractEdate"
            :maxDate="afterYear(5)"
            @confirm-values="val => contractEdate = val"
          />
          <Field
            name="handlerName"
            label="经办人"
            :require="true"
            :defaultValue="handlerName"
          />
          <Field
            name="handlerTel"
            label="经办人电话"
            :require="true"
            :defaultValue="handlerTel"
          />
          <van-field name="uploader" >
            <template #input>
              <van-uploader  v-model="fileList" :after-read="afterRead" :show-upload="showUpload"   />
            </template>
          </van-field>
          <div class="btn">
            <van-button
              block
              type="primary"
              :loading="loading"
              loading-text="请稍后..."
              :disabled="loading"
              native-type="button"
              @click="onSubmit"
            >
              提交
            </van-button>
          </div>
      </van-form>
  </Popup>
</template>

<script>
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Dialog, Toast, Notify } from 'vant'
import { getAgentMesslist, getAgentCustomerMesslist } from '@/api/agentMess'
import { deletetCustom, getCustomerLogList, getCustomerDetail, batchAddUserContract } from '@/api/customer'
import getImgFile from '@/utils/getImgFile'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { afterYear } from '@/utils/common'
export default {
  name: 'SaleAgentMessInfo', // 批发商列表
  props: [],
  setup (prop) {
    const showHistory = ref(false)
    const popup = ref(null)
    const dMess = ref({})
    const cList = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const store = useStore()
    const searchWord = ref('') // 搜索关键词
    const router = useRouter()
    const departId = computed(() => store.state.roleInfo.departId)
    // 获取公司信息
    const getAgentMess = async () => {
      const { status, data } = await getAgentMesslist(departId.value)
      if (status === 200) {
        dMess.value = data
      }
    }
    const pa = reactive({
      departId: departId.value,
      cName: searchWord.value
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getAgentCustomerMesslist, (data) => {
      cList.value = data
    }, pa)
    // search
    const onSearch = (value) => {
      searchWord.value = value
      pa.cName = value
      getDataLoading()
    }
    const handleComClick = (item) => {
      if (item.status === '03' || item.status === '02') {
        router.push(`/developUsers/${item.customerId}`)
      } else {
        router.push(`/userInfo/${item.customerId}`)
      }
    }

    const handleDelClick = (id) => {
      Dialog.confirm({
        title: '删除',
        message: '确定要永久删除该客户？'
      })
        .then(async () => {
          // on confirm
          try {
            const { status } = await deletetCustom(id)
            if (status === 200) {
              Notify({ type: 'success', message: '删除成功' })
              getDataLoading()
            } else {
              getDataLoading()
            }
            Toast.clear()
          } catch {
            Toast.clear()
          }
        })
        .catch(() => {
          // on cancel
        })
    }
    const goBack = () => {
      router.push('/message')
    }
    const toastInfo = (message) => {
      Toast(message)
    }
    getAgentMess()
    getDataLoading()

    const historyList = ref([])
    const handleHistoryClick = (id) => {
      showHistory.value = true
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在查询'
      })
      getCustomerLogList(id).then(res => {
        historyList.value = res.data || []
        Toast.clear()
        popup.value.showPopup()
      }).catch(() => {
        Toast.clear()
      })
    }
    const userId = ref('')
    const contractSdate = ref('')
    const contractEdate = ref('')
    const handlerName = ref('')
    const handlerTel = ref('')
    const handleModClick = (id) => {
      showHistory.value = false
      userId.value = id
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在查询'
      })
      getCustomerDetail(id).then(res => {
        fileList.value = res.data.imgList ? res.data.imgList.map(item => ({ url: item, status: 'done' })) : []
        Toast.clear()
        contractSdate.value = res.data.contractSdate
        contractEdate.value = res.data.contractEdate
        handlerName.value = res.data.handlerName
        handlerTel.value = res.data.handlerTel
        popup.value.showPopup()
      }).catch(() => {
        Toast.clear()
      })
    }
    // 文件上传
    const fileList = ref([])
    const showUpload = ref(true)
    const imgPath = computed(() => {
      const arr = []
      fileList.value.forEach(item => {
        if (item.status === 'done') {
          arr.push(item.content || item.url)
        }
      })
      return arr
    })
    const afterRead = (file) => {
      getImgFile(file, fileList, showUpload)
    }
    const onSubmit = () => {
      loading.value = true
      batchAddUserContract({
        userId: userId.value,
        imgList: imgPath.value,
        contractSdate: contractSdate.value,
        contractEdate: contractEdate.value,
        handlerTel: handlerTel.value,
        handlerName: handlerName.value
      }).then(() => {
        popup.value.hidePopup()
        loading.value = false
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => {
        loading.value = false
      })
    }
    return {
      getDataLoading,
      isLoading,
      showLoading,
      loading,
      finished,
      cList,
      dMess,
      getAgentMess,
      handleDelClick,
      handleComClick,
      searchWord,
      onSearch,
      pa,
      goBack,
      toastInfo,
      popup,
      handleHistoryClick,
      historyList,
      afterRead,
      onSubmit,
      handleModClick,
      showHistory,
      fileList,
      showUpload,
      contractSdate,
      contractEdate,
      afterYear,
      handlerTel,
      handlerName
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-title {
  font-size: 14px;
}
.btn {
  margin: 16px;
}
.btns {
  padding: 0 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #d8d8d8;
}
  .form {
    margin-bottom: 16px;
  }
  .btn-conatiner {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
  }
  .department {
    font-size: 14px;
    font-weight: 400;
    color: #333;
    padding: 16px;
  }
  .row-btn {
    margin: 16px;
  }
  ::v-deep(.van-cell__value) {
    flex: initial;
    margin-left: 10px;
  }
.list {
  padding: 0 16px;
  .list-item {
    margin-top: 10px;
    line-height: 24px;
    &__name {
      font-size: 12px;
      font-weight: 600;
    }
    &__content {
      background-color:#d8d8d8;
      font-size: 12px;
      padding: 10px;
    }
  }
}
.van-col {
  margin-bottom: 10px;
}
</style>
